export default __webpack_public_path__ + "static/media/31t.e586f0d3.jpg";